import { useMemo } from 'react'

export default function useInitial<T>(value: T): T extends () => infer R ? R : T {
  return useMemo(() => (typeof value === 'function' ? value() : value), [])
}
